import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityLogComponent } from './components/activity-log/activity-log.component';
import { DirectivesModule } from './directives/directives.module';
import { PipesModule } from './pipes/pipes.module';

@NgModule({
  imports: [CommonModule, DirectivesModule, PipesModule],
  declarations: [ActivityLogComponent],
  exports: [ActivityLogComponent]
})
export class VicodersActivityLogModule {}
